import request from '../../helpers/request';

import { QueryKeys } from '../../config/constants/react-query';
import { BASE_URL } from '../../config/constants/contants';

import { TGetMonthlyExhibitResponse } from '../../types/TGetMonthlyExhibitResponse';
import { TSupportedLanguages } from '../../types/TSupportedLanguages';

const useGetMonthlyExhibit = (
  language: TSupportedLanguages,
  isHome: boolean,
) => {
  const { data, isLoading, error, refetch } =
    request<TGetMonthlyExhibitResponse>(
      `${BASE_URL}/api/v1/monthly-exhibit?language=${language}&isHome=${isHome}`,
      QueryKeys.MonthlyExhibit,
      true,
    );

  return { data, isLoading, error, refetch };
};

export default useGetMonthlyExhibit;
